(function() {
    "use strict";

    taillightUx.directive('tuxSnapScrollerItem', TuxSnapScrollerItem);

    function TuxSnapScrollerItem() {

        return {
            require: "^?tuxSnapScroller",
            terminal: true,
            link: postLink
        }

        function postLink(scope, element, attr, ctrl) {

            if (!ctrl) return;

            var item = element[0];
            if (item) {

                ctrl.insertItem( { innerHtml: item.innerHTML } );
                angular.element(item).remove();
            }
        }
    };

    taillightUx.directive('tuxSnapScroller', ['$document', TuxSnapScroller]);

    function TuxSnapScroller($document) {

        return {

            template: function(element, attr) {

                attr["$tuxSnapScrollerTemplate"] = getTemplate();

                return  '<tux-snap-wrapper>' +
                    '<tux-snap-prev-button ng-class="{ \'md-disabled\': !ctrl.canPageBack() }" ng-click="ctrl.prevPage()" ng-if="ctrl.shouldPaginate">' +
                    '<span class="icon-snap-advancer"><span class="path1"></span><span class="path2"></span></span>' +
                    '</tux-snap-prev-button>' +
                    '<tux-snap-next-button ng-class="{ \'md-disabled\': !ctrl.canPageForward() }" ng-click="ctrl.nextPage()" ng-if="ctrl.shouldPaginate">' +
                    '<span class="icon-snap-advancer"><span class="path1"></span><span class="path2"></span></span>' +
                    '</tux-snap-next-button>' +
                    '<tux-snap-canvas ng-class="{\'md-paginated\': ctrl.shouldPaginate }">' +
                    '<tux-snap-pagination-wrapper>' +
                    '<tux-snap-item layout-padding ng-repeat="item in ctrl.items">' +
                    '<div class="item" tux-bind-html-compile="item.innerHtml"></div>' +
                    '</tux-snap-item>' +
                    '</tux-snap-pagination-wrapper>' +
                    '</tux-snap-canvas>' +
                    '</tux-snap-wrapper>';


                function getTemplate() {
                    var content = element.eq(0),
                        template = content.length ? content.html() : '';
                    return template;
                }
            },
            restrict: 'E',
            controller: ['$scope', '$element', '$window', '$mdConstant', '$mdTabInkRipple', '$mdUtil', '$animateCss', '$attrs', '$compile', '$timeout', '$rootScope', snapScrollerController],
            controllerAs: 'ctrl'
        }
    }

    var snapScrollerController = function ($scope, $element, $window, $mdConstant, $mdTabInkRipple,$mdUtil, $animateCss, $attrs, $compile, $timeout, $rootScope) {

        // For some reason nextTick() method is not available on $mdUtil???
        $mdUtil.nextTick = function(callback, digest, scope) {
            //-- grab function reference for storing state details
            var nextTick = $mdUtil.nextTick;
            var timeout = nextTick.timeout;
            var queue = nextTick.queue || [];

            //-- add callback to the queue
            queue.push(callback);

            //-- set default value for digest
            if (digest == null) digest = true;

            //-- store updated digest/queue values
            nextTick.digest = nextTick.digest || digest;
            nextTick.queue = queue;

            //-- either return existing timeout or create a new one
            return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

            /**
             * Grab a copy of the current queue
             * Clear the queue for future use
             * Process the existing queue
             * Trigger digest if necessary
             */
            function processQueue() {
                var skip = scope && scope.$$destroyed;
                var queue = !skip ? nextTick.queue : [];
                var digest = !skip ? nextTick.digest : null;

                nextTick.queue = [];
                nextTick.timeout = null;
                nextTick.digest = false;

                queue.forEach(function(callback) {
                    callback();
                });

                if (digest) $rootScope.$digest();
            }
        };

        var ctrl      = this,
            elements  = getElements(),
            destroyed = false;

        // define public properties with change handlers
        defineProperty('offsetLeft', handleOffsetChange, 0);
        defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
        defineProperty('shouldPaginate', handleShouldPaginate, false);

        // define public properties
        ctrl.scope              = $scope;
        ctrl.parent             = $scope.$parent;
        ctrl.items              = [];


        // define public methods
        ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
        ctrl.insertItem         = insertItem;
        ctrl.nextPage           = nextPage;
        ctrl.prevPage           = prevPage;
        ctrl.canPageForward     = canPageForward;
        ctrl.canPageBack        = canPageBack;

        init();

        function init () {
            compileTemplate();
            bindEvents();
            $mdUtil.nextTick(function () {
                updatePagination();
            });
        }

        function compileTemplate () {

            var template = $attrs.$tuxSnapScrollerTemplate;

            $element.append(template);
            $compile($element.contents())(ctrl.parent);
            delete $attrs.$tuxSnapScrollerTemplate;
        }

        /**
         * Binds events used by the tabs component.
         */
        function bindEvents () {
            angular.element($window).on('resize', handleWindowResize);
            $scope.$on('$destroy', cleanup);
        }

        /**
         * Remove any events defined by this controller
         */
        function cleanup () {
            destroyed = true;
            angular.element($window).off('resize', handleWindowResize);
        }

        /**
         * Update size calculations when the window is resized.
         */
        function handleWindowResize () {
            ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
            $mdUtil.nextTick(function () {
                updatePagination();
            });
        }

        /**
         * Apply ctrl.offsetLeft to the paging element when it changes
         * @param left
         */
        function handleOffsetChange (left) {
            var newValue = '-' + left + 'px';
            angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
            $scope.$broadcast('$mdTabsPaginationChanged');
        }

        function insertItem (item) {
            ctrl.items.push(item);
        }

        /**
         * Gathers references to all of the DOM elements used by this controller.
         * @returns {{}}
         */
        function getElements () {
            var elements = {};

            // gather tab bar elements
            elements.wrapper = $element[ 0 ].getElementsByTagName('tux-snap-wrapper')[ 0 ];
            elements.canvas  = elements.wrapper.getElementsByTagName('tux-snap-canvas')[ 0 ];
            elements.paging  = elements.canvas.getElementsByTagName('tux-snap-pagination-wrapper')[ 0 ];
            elements.items    = elements.paging.getElementsByTagName('tux-snap-item');

            return elements;
        }

        /**
         * Determines if pagination is necessary to display the tabs within the available space.
         * @returns {boolean}
         */
        function shouldPaginate () {
            var canvasWidth = $element.prop('clientWidth');
            angular.forEach(elements.items, function (item) {
                canvasWidth -= item.offsetWidth;
            });
            return canvasWidth < 0;
        }

        /**
         * Defines a property using a getter and setter in order to trigger a change handler without
         * using `$watch` to observe changes.
         * @param key
         * @param handler
         * @param value
         */
        function defineProperty (key, handler, value) {
            Object.defineProperty(ctrl, key, {
                get: function () { return value; },
                set: function (newValue) {
                    var oldValue = value;
                    value        = newValue;
                    handler && handler(newValue, oldValue);
                }
            });
        }

        /**
         * Updates whether or not pagination should be displayed.
         */
        function updatePagination () {
            ctrl.shouldPaginate = shouldPaginate();
        }

        function getMaxTabWidth () {
            return $element.prop('clientWidth');
        }

        function handleMaxTabWidth (newWidth, oldWidth) { }

        function handleShouldPaginate (newValue, oldValue) {
            if (newValue !== oldValue) {
                ctrl.maxTabWidth      = getMaxTabWidth();
                $mdUtil.nextTick(function(){
                    ctrl.maxTabWidth = getMaxTabWidth();
                });
            }
        }


        /**
         * Determines whether or not the left pagination arrow should be enabled.
         * @returns {boolean}
         */
        function canPageBack () {
            return ctrl.offsetLeft > 0;
        }

        /**
         * Determines whether or not the right pagination arrow should be enabled.
         * @returns {*|boolean}
         */
        function canPageForward () {
            var lastTab = elements.items[ elements.items.length - 1 ];
            return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth + ctrl.offsetLeft;
        }

        function nextPage() {
            var viewportWidth = elements.canvas.clientWidth,
                totalWidth    = viewportWidth + ctrl.offsetLeft,
                i, item;
            for (i = 0; i < elements.items.length; i++) {
                item = elements.items[ i ];
                if (item.offsetLeft + item.offsetWidth > totalWidth) break;
            }
            ctrl.offsetLeft = fixOffset(item.offsetLeft);
        }

        function prevPage() {
            var i, item;
            for (i = 0; i < elements.items.length; i++) {
                item = elements.items[ i ];
                if (item.offsetLeft + item.offsetWidth >= ctrl.offsetLeft) break;
            }
            ctrl.offsetLeft = fixOffset(item.offsetLeft + item.offsetWidth - elements.canvas.clientWidth);
        }

        /**
         * Takes an offset value and makes sure that it is within the min/max allowed values.
         * @param value
         * @returns {*}
         */
        function fixOffset (value) {
            if (!elements.items.length || !ctrl.shouldPaginate) return 0;
            var lastTab    = elements.items[ elements.items.length - 1 ],
                totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
            value          = Math.max(0, value);
            value          = Math.min(totalWidth - elements.canvas.clientWidth, value);
            return value;
        }
    };

}());